export enum MenuCategoryEnum {
    MAIN,
    ADMIN,
    DEVELOPER
}